$.ajaxSetup({
  headers: {
    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
  }
});

var pageloaded = 1;
// Hide Header on on scroll down
var didScroll;
var lastScrollTop = 0;
var delta = 5;

if (reader_mode == 'all') {
  allMode();
}

function allMode() {

  infinteLoadMore(pageloaded);

  if (pageloaded == 1) {
    var winScroll = document.body.scrollTop || document.documentElement.scrollTop;
    var webtoonHeight = $('.indicator2').offset().top - $('.indicator1').offset().top;
    var height = webtoonHeight - document.documentElement.clientHeight;
    if (winScroll > height && pageloaded && pagecount > 1) {
      pageloaded++;
      infinteLoadMore(pageloaded);
    }
  }


  $(window).scroll(function(event) {
    didScroll = true;
  });

  setInterval(function() {
    if (didScroll) {
      hasScrolled();
      didScroll = false;
    }
  }, 250);
}

function hasScrolled() {
  var st = $(this).scrollTop();

  // Make sure they scroll more than delta
  if (Math.abs(lastScrollTop - st) <= delta)
    return;

  // If they scrolled down and are past the navbar, add class .nav-up.
  // This is necessary so you never see what is "behind" the navbar.
  var winScroll = document.body.scrollTop || document.documentElement.scrollTop;
  var webtoonHeight = $('.indicator2').offset().top - $('.indicator1').offset().top;
  var height = webtoonHeight - document.documentElement.clientHeight;
  var scrolled = (winScroll / height) * 100;
  if ((st > lastScrollTop && scrolled > 95) || (winScroll > height && pageloaded < pagecount && pageloaded > 1)) {
    pageloaded++;
    if (pageloaded <= pagecount) {
      $('.auto-load').show();
      infinteLoadMore(pageloaded);
    }
  }

  lastScrollTop = st;
}

function infinteLoadMore(page) {
  image2 = 'https://' + cdn + '.manga-mana.com/uploads/manga/' + oeuvre_slug + '/chapters_fr/' + chapter_slug + '/' + pages[page - 1].image + '?' + pages[page - 1].version;
  if (page >= pagecount) {
    $("#data-wrapper").append('<a href="' + next_chapter + '"><img class="img-fluid mx-auto d-block" src="' + image2 + '"></a>');
  } else {
    $("#data-wrapper").append('<img class="img-fluid mx-auto d-block" src="' + image2 + '">');
  }
  $('.auto-load').hide();
}
if (reader_mode == 'ppp') {
  pppMode();
}

function pppMode() {

  State = History.getState();
  url = location.href.substr(base_url.length);
  if (url == "") {
    url = 1;
  } else {
    url = parseInt(State.url.substr(State.url.lastIndexOf('/') + 1));
  }
  current_page = url;
  History.pushState(null, null, base_url + '/' + current_page);
  changePage(current_page, false, true);

}

document.title = title;
update_numberPanel();

// refresh test
function changePage(id, noscroll, nohash) {
  id = parseInt(id);

  if (initialized && id == current_page)
    return false;
  initialized = true;
  if (id == pages.length) {
    if (next_chapter == "") {
      $('.next-page').hide();
    }
  } else if (id > pages.length) {
    if (next_chapter == "") {
      location.href = oeuvre_url;

    } else {
      location.href = next_chapter;
    }

    return false;
  } else {
    $('.next-page').show();
  }

  if (id == 1) {
    if (prev_chapter == oeuvre_url) {
      $('.prev-page').hide();
    }
  } else if (id <= 0) {
    if (prev_chapter == "") {
      alert('Vous êtes sur la première page.');
    } else {
      location.href = prev_chapter;
    }

    return false;
  } else {
    $('.prev-page').show();
  }

  preload(id);
  current_page = id;
  next = parseInt(id + 1);

  jQuery("html, body").stop(true, true);
  jQuery('.scan-page').parent().html("<img class='scan-page img-fluid mx-auto'>");
  jQuery('.scan-page').attr('src', 'https://' + cdn + '.manga-mana.com/uploads/manga/' + oeuvre_slug + '/chapters_fr/' + chapter_slug + '/' + pages[current_page - 1].image + '?' + pages[current_page - 1].version);

  if (!nohash)
    History.pushState(null, null, base_url + '/' + current_page);
  document.title = title;
  update_numberPanel();
  return false;
}

function nextPage() {
  changePage(current_page + 1);
  $("html, body").animate({
    scrollTop: $('div.reader-page__page-nav').eq(0).offset().top
  });
  return false;
}
window.nextPage = nextPage;

function prevPage() {
  changePage(current_page - 1);
  return false;
}
window.prevPage = prevPage;

function nextChap() {
  window.location = next_chapter;
}
window.nextChap = nextChap;

function prevChap() {
  window.location = prev_chapter;
}
window.prevChap = prevChap;


function preload(id) {
  var array = [];
  var arraydata = [];
  for (i = -preload_back; i < preload_next; i++) {
    if (id + i >= 0 && id + i < pages.length) {
      if (pages[(id + i)].external == 0) {
        array.push('https://' + cdn + '.manga-mana.com/uploads/manga/' + oeuvre_slug + '/chapters_fr/' + chapter_slug + '/' + pages[(id + i)].image + '?' + pages[(id + i)].version);
      } else {
        array.push(pages[(id + i)].image + '?' + pages[(id + i)].version);
      }
      arraydata.push(id + i);
    }
  }

  jQuery.preload(array, {
    threshold: 40,
    enforceCache: true,
    onComplete: function(data) {}
  });
}

function update_numberPanel() {
  $('#page-list').val(current_page);
}

$('a#modePPP').click(function(e) {
  e.preventDefault();
  var reader_mode = "ppp";
  pppMode();
  Cookies.set('reader_mode', 'ppp');
  $('.page_changer').removeClass('d-none');
  $('div#ppp').removeClass('d-none');
  $('div#all').addClass('d-none');
  $(document).on('keyup', function(e) {
    KeyCheck(e);
  });
});

$('a#modeALL').click(function(e) {
  e.preventDefault();
  var reader_mode = "all";
  allMode();
  Cookies.set('reader_mode', 'all');
  $('.page_changer').addClass('d-none');
  $('div#ppp').addClass('d-none');
  $('div#all').removeClass('d-none');
  $(document).off('keyup');
});

$('select#page-list').on('change', function() {
  changePage(this.value);
});

$(document).on('keyup', function(e) {
  KeyCheck(e);
});

function KeyCheck(e) {
  var ev = e || window.event;
  ev.preventDefault();
  var KeyID = ev.keyCode;
  switch (KeyID) {
    case 36:
      window.location = oeuvre_url;
      break;
    case 33:
    case 37:
      prevPage();
      break;
    case 34:
    case 39:
      nextPage();
      break;
  }
}

// To disable right click
document.addEventListener('contextmenu', event => event.preventDefault());

// To disable F12 options
document.onkeypress = function(event) {
  event = (event || window.event);
  if (event.keyCode == 123) {
    return false;
  }
}
document.onmousedown = function(event) {
  event = (event || window.event);
  if (event.keyCode == 123) {
    return false;
  }
}
document.onkeydown = function(event) {
  event = (event || window.event);
  if (event.keyCode == 123) {
    return false;
  }
}

// To Disable ctrl+c, ctrl+u

jQuery(document).ready(function($) {
  $(document).keydown(function(event) {
    var pressedKey = String.fromCharCode(event.keyCode).toLowerCase();

    if (event.ctrlKey && (pressedKey == "c" || pressedKey == "u")) {
      return false;
    }
  });
});